import { TalkhattabatConversationType } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ConversationType from "./ConversationType";
import ConverstionStates from "./conversation-states";

const Header = withLiteObserverAndTheme<{
  conversationID: string;
  conversationType: TalkhattabatConversationType;
  matchName: string;
  exitByMatch: boolean;
  exitByClient: boolean;
  exitedByClientDate: Date;
  exitedByMatchDate: Date;
  pendingInteraction: boolean;
  peerID: number;
  clientConversationID: string;
  oneOTwoConversationId: string;
  clientID: number
}>((props) => {
  const {
    theme,
    conversationType,
    conversationID,
    matchName,
    exitByMatch,
    exitByClient,
    exitedByClientDate,
    exitedByMatchDate,
    pendingInteraction,
    peerID,
    oneOTwoConversationId,
    clientConversationID,
    clientID
  } = props;
  const { colors } = theme;

  return (
    <ET3Div
      width={1450}
      height={50}
      alignItems={"center"}
      fDirection={"row"}
      style={{
        borderTop:
          conversationType === "101C"
            ? 0
            : `1px solid ${colors.all.shadeOfGray}`
      }}
      color={""}
      justifyContent={"space-between"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <ConversationType
        conversationType={conversationType}
        matchName={matchName}
        peerID={peerID}
      />
      <ConverstionStates
        exitedByMatch={exitByMatch}
        exitedByClient={exitByClient}
        exitedByClientDate={exitedByClientDate}
        exitedByMatchDate={exitedByMatchDate}
        pendingInteraction={pendingInteraction}
        conversationID={conversationID}
        conversationType={conversationType}
        clientConversationID={clientConversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        clientID={clientID}
      />
    </ET3Div>
  );
});

export default Header;
